import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import styled from '@emotion/styled';
import { Box } from '../box';
const getWidthPixelsFromWidthProp = (width) => {
    switch (width) {
        case 1:
            return '100%';
        case 0.5:
            return 'calc(50% - 8px)';
        case 0.25:
            return 'calc(25% - 8px)';
        default:
            return '100%';
    }
};
const Wrapper = styled.div `
  margin-bottom: ${({ theme }) => theme.space.s}px;
  width: ${(props) => props.width};
`;
export const FieldWrapper = ({ children, width = 1, }) => {
    const widthPixels = useMemo(() => {
        if (Array.isArray(width)) {
            return width.map((v) => getWidthPixelsFromWidthProp(v));
        }
        return getWidthPixelsFromWidthProp(width);
    }, [width]);
    return (_jsx(Wrapper, { width: widthPixels, children: _jsx(Box, { children: children }) }));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRmllbGRXcmFwcGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvZmllbGQtd3JhcHBlci9GaWVsZFdyYXBwZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxPQUFjLEVBQUUsT0FBTyxFQUEwQixNQUFNLE9BQU8sQ0FBQztBQUMvRCxPQUFPLE1BQU0sTUFBTSxpQkFBaUIsQ0FBQztBQUNyQyxPQUFPLEVBQUUsR0FBRyxFQUFFLE1BQU0sUUFBUSxDQUFDO0FBZ0I3QixNQUFNLDJCQUEyQixHQUFHLENBQUMsS0FBWSxFQUFFLEVBQUU7SUFDbkQsUUFBUSxLQUFLLEVBQUUsQ0FBQztRQUNkLEtBQUssQ0FBQztZQUNKLE9BQU8sTUFBTSxDQUFDO1FBQ2hCLEtBQUssR0FBRztZQUNOLE9BQU8saUJBQWlCLENBQUM7UUFDM0IsS0FBSyxJQUFJO1lBQ1AsT0FBTyxpQkFBaUIsQ0FBQztRQUMzQjtZQUNFLE9BQU8sTUFBTSxDQUFDO0lBQ2xCLENBQUM7QUFDSCxDQUFDLENBQUM7QUFFRixNQUFNLE9BQU8sR0FBRyxNQUFNLENBQUMsR0FBRyxDQUFtQjttQkFDMUIsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLENBQUM7V0FDcEMsQ0FBQyxLQUFLLEVBQUUsRUFBRSxDQUFDLEtBQUssQ0FBQyxLQUFLO0NBQ2hDLENBQUM7QUFFRixNQUFNLENBQUMsTUFBTSxZQUFZLEdBQW1ELENBQUMsRUFDM0UsUUFBUSxFQUNSLEtBQUssR0FBRyxDQUFDLEdBQ1YsRUFBRSxFQUFFO0lBQ0gsTUFBTSxXQUFXLEdBQUcsT0FBTyxDQUFDLEdBQUcsRUFBRTtRQUMvQixJQUFJLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSyxDQUFDLEVBQUUsQ0FBQztZQUN6QixPQUFPLEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLEVBQUUsRUFBRSxDQUFDLDJCQUEyQixDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUM7UUFDMUQsQ0FBQztRQUNELE9BQU8sMkJBQTJCLENBQUMsS0FBSyxDQUFDLENBQUM7SUFDNUMsQ0FBQyxFQUFFLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQztJQUVaLE9BQU8sQ0FDTCxLQUFDLE9BQU8sSUFBQyxLQUFLLEVBQUUsV0FBcUIsWUFDbkMsS0FBQyxHQUFHLGNBQUUsUUFBUSxHQUFPLEdBQ2IsQ0FDWCxDQUFDO0FBQ0osQ0FBQyxDQUFDIn0=